import React from 'react'
import PropTypes from 'prop-types'
import { intlMessageShape } from 'sb-react-intl'
import { useRef, useCallback } from 'sb-hooks'

import Headline from 'components/_new/typography/deprecated/Headline/Headline'
import CloseIcon from 'components/ui/CloseIcon/CloseIcon'

import s from './MobileModal.scss'


const MobileModal = ({ title, children, onBackdropClick, onClose }) => {
  const ref = useRef()

  const measuredRef = useCallback((node) => {
    if (node) {
      ref.current = node

      setTimeout(() => {
        ref.current.classList.add(s.visible)
      }, 0)
    }
  }, [])

  const handleBackdropClick = useCallback(() => {
    ref.current.classList.remove(s.visible)

    setTimeout(() => {
      if (typeof onBackdropClick === 'function') {
        onBackdropClick()
      }
    }, 300)
  }, [ onBackdropClick ])

  return (
    <div ref={measuredRef}>
      <div
        className={s.modal}
        role="dialog"
        aria-modal
      >
        {
          typeof onClose === 'function' && (
            <CloseIcon className={s.closeIcon} onClick={onClose} />
          )
        }
        {
          title && (
            <Headline title={title} size="md" />
          )
        }
        {children}
      </div>
      <div className={s.backdrop} onClick={handleBackdropClick} />
    </div>
  )
}

MobileModal.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape(intlMessageShape),
  ]),
  children: PropTypes.any,
  onBackdropClick: PropTypes.func,
}


export default MobileModal
